import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ItemHeader from 'containers/ManageAccess/ItemHeader'
import { useIsSmallScreen } from 'packages/core'
import { Loader } from 'packages/eid-ui'
import {
    useAzureLicense,
    useCheckAzureLicenseAccess,
    useTargetPerson,
} from 'hooks'
import AzureLicenseDetails from './AzureLicenseDetails'
import { ManageAccessDrawer } from 'components/Drawer/ManageAccessDrawer'

const AzureLicencesDrawer = ({ id, attributes, toggleDrawer, ...rest }) => {
    const isSmallScreen = useIsSmallScreen()
    const headerAttribute = attributes.find((x) => x.isHeader)

    const [targetPerson] = useTargetPerson()

    const { data: assignmentStatus } = useCheckAzureLicenseAccess(
        id,
        targetPerson.id,
    )

    const { data: azureLicense } = useAzureLicense(id)

    let item
    if (azureLicense && assignmentStatus) {
        item = {
            resource: azureLicense,
            assignment: assignmentStatus,
        }
    }

    const itemDetails = <AzureLicenseDetails item={item} {...rest} />

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={item?.resource?.[headerAttribute.name]} />
            {!item && <Loader />}
            {item && itemDetails}
        </ItemsDetailsMobileWrapper>
    ) : (
        <ManageAccessDrawer
            id={id}
            toggleDrawer={toggleDrawer}
            item={item}
            itemDetails={itemDetails}
            headerAttribute={headerAttribute}
        />
    )
}

export default AzureLicencesDrawer
